// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"332":"PostSale","339":"Checkout"}[chunkId] || chunkId) + "." + {"196":"6cf8b1ac","332":"6709d64e","339":"08ce2d5f","525":"203688e2","727":"53f9e7fa","834":"ec456a97","995":"fc4931ac"}[chunkId] + ".chunk.js";
};